import { jsxs as o, jsx as r } from "@emotion/react/jsx-runtime";
import { Fragment as l } from "react";
import { FilesDetails as d } from "./RejectedMultipleDocumentThumb.styled.js";
import { Icon as g } from "../../Icon/index.js";
import { Stack as m } from "../../Stack/index.js";
import { Text as n } from "../../Text/index.js";
import { DocumentSvg as h } from "../icons/DocumentSvg.js";
import { PhotoSvg as u } from "../icons/PhotoSvg.js";
import { ErrorList as f } from "../ErrorList/ErrorList.js";
import { DropzoneTypeEnum as i } from "../../../types/components/dropzone.js";
const F = ({
  files: e,
  type: a = i.Document,
  errorTitle: p,
  errorTranslations: c
}) => /* @__PURE__ */ o(m, { direction: "row", alignItems: "flex-start", children: [
  /* @__PURE__ */ r(g, { icon: a === i.Document ? /* @__PURE__ */ r(h, { state: "error" }) : /* @__PURE__ */ r(u, { state: "error" }), iconSize: "32px", color: "danger" }),
  /* @__PURE__ */ o(d, { gap: "4px", children: [
    /* @__PURE__ */ o(n, { variant: "bodyLSemibold", as: "span", children: [
      e.length,
      " ",
      p
    ] }),
    /* @__PURE__ */ r(m, { gap: "0", children: e.map(({
      file: t,
      errors: s
    }) => /* @__PURE__ */ o(l, { children: [
      /* @__PURE__ */ r(n, { variant: "bodyMRegular", as: "span", children: t.name }),
      /* @__PURE__ */ r(f, { errors: s, errorTranslations: c }, t.name)
    ] }, t.name)) })
  ] })
] });
export {
  F as RejectedMultipleDocumentThumb
};
